import { Box, Button, Card, CardActions, CardContent } from "@mui/material";
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import styles from './AppDetails.module.css'
import AppVersions from "./AppVersions";
import { useCallback, useEffect, useState } from "react";
import { HidingError } from "components/errors";
import { CircularProgress } from "components/overlays";

import AppOptions from "./AppOptions";
import { useGetAppVersionsQuery } from "services/data/appApi";
import { isEqual } from 'lodash';

const AppDetails = ({item, saveDetails}) => { 
    
    const { data, isError, error,  isFetching } = useGetAppVersionsQuery({packageName: item.packageName});
    const [details, setDetails] = useState(data?.body?.items);
    
    const [options, setOptions] = useState({
      licenceOnly: data?.body?.licenceOnly ?? false,
      profileOnly: data?.body?.profileOnly ?? false,
      signatureOnly: data?.body?.signatureOnly ?? false,
      trial: data?.body?.trial
    });

    useEffect(() => {
      setOptions({
        licenceOnly: data?.body?.licenceOnly ?? false,
        profileOnly: data?.body?.profileOnly ?? false,
        signatureOnly: data?.body?.signatureOnly ?? false,
        trial: data?.body?.trial
      });
      setDetails(data?.body?.items);
    }, [data]);

    const changeVersions = (value) => {
      setDetails(value);
    };

    const changeOptions = (value) => { 
      setOptions(old => ({...options, ...value}));
    };

    if(isError) {
        return <>{error.status} {JSON.stringify(error.data)}</>;
    }

    if(isFetching) {
        return <>Загрузка...</>;
    };

    const isSaveButtonDisabled = () => { 
      return (options.trial == data?.body?.trial) && (options.licenceOnly == data?.body?.licenceOnly) && 
                (options.profileOnly == data?.body?.profileOnly) &&
                 (options.signatureOnly == data?.body?.signatureOnly) && isEqual(data?.body?.items, details);
    };

    return (
      <>
        <CircularProgress open={false}/>
        <Card sx={{maxHeight: '100%', display: 'flex', flexDirection: 'column'}}>
            <CardContent sx={{overflow: 'auto'}}>
                <AppOptions
                  name={item.name}
                  packageName={item.packageName}
                  trial={options.trial}
                  profileOnly={options.profileOnly}
                  licenceOnly={options.licenceOnly}
                  signatureOnly={options.signatureOnly}
                  onChange={changeOptions}
                />
                <AppVersions 
                  packageName={item.packageName}
                  name={item.name}
                  data={details}
                  ecrModels={["TPS570Q", "TPS570"]}
                  onChange={changeVersions}
                />
            </CardContent>
            <CardActions sx={{px: 2}}>
              <Button
                fullWidth
                disabled={isSaveButtonDisabled()}
                startIcon={<SaveOutlinedIcon/>}
                color='error'
                variant='contained'
                sx={{my: 1}}
                onClick={()=>saveDetails(item.packageName, options, details)}
              >Сохранить</Button>    
            </CardActions>
        </Card>
      </>  
    );
};

export default AppDetails;